import { values } from 'lodash';

import { RootState } from 'src/state/rootReducer';

export const getCustomers = (state: RootState) => {
  return values(state.entities.customers.byId);
};
